import Keycloak from "keycloak-js";
const _kc = Keycloak({ url: window.location.origin + "/auth", clientId: "exfluency-frontend", realm: "exfluency-realm" });
const MARKEN_SSO_COOKIE = 'exfluency_marken_sso';
const isMarkenSsoEntry = () => window.location.pathname.split('/').includes('marken');
/** Shared across ecosystem + portal on *.exfluency.com; host-only on localhost (all ports). */
const markenSsoCookieSuffix = () => {
    let suffix = 'Path=/; Max-Age=2147483647; SameSite=Lax';
    const host = window.location.hostname;
    if (host.endsWith('.exfluency.com')) {
        suffix += '; Domain=.exfluency.com';
    }
    if (window.location.protocol === 'https:') {
        suffix += '; Secure';
    }
    return suffix;
};
const rememberMarkenSsoEntry = () => {
    document.cookie = `${MARKEN_SSO_COOKIE}=1; ${markenSsoCookieSuffix()}`;
};
/** Drop /marken from the current URL so Keycloak redirect_uri is not that path. Keeps origin, other path parts, query, hash. */
const stripMarkenPathFromLocation = () => {
    const url = new URL(window.location.href);
    const segments = url.pathname.split('/').filter(segment => segment.length > 0 && segment !== 'marken');
    url.pathname = '/' + segments.join('/');
    const next = `${url.pathname}${url.search}${url.hash}`;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (next !== current) {
        window.history.replaceState(window.history.state, '', next);
    }
};
const initKeycloak = (onAuthenticatedCallback) => {
    if (isMarkenSsoEntry()) {
        rememberMarkenSsoEntry();
        stripMarkenPathFromLocation();
    }
    _kc.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/auth/silent-check-sso.html',
        pkceMethod: 'S256'
    })
        .then((authenticated) => {
        if (!authenticated && !unauthenticatedPath()) {
            doLogin();
        }
        onAuthenticatedCallback();
    })
        .catch(console.error);
};
const unauthenticatedPath = () => ['/logout', '/forgot-password', '/signup', '/resend-link', '/terms-of-service', '/privacy-notice', '/api/auth/signup/active'].some(e => e === window.location.pathname)
    || window.location.pathname.includes('/verify-email') || window.location.pathname.includes('/reset-password')
    || window.location.pathname.includes('/auth')
    || window.location.pathname.includes('/translation-certificate');
const doLogin = _kc.login;
const doLogout = _kc.logout;
const getToken = () => _kc.token;
const isLoggedIn = () => !!_kc.token;
const updateToken = (successCallback) => _kc.updateToken(10)
    .then(successCallback)
    .catch(doLogin);
const getUsername = () => { var _a; return (_a = _kc.profile) === null || _a === void 0 ? void 0 : _a.username; };
const getTokenUserInfo = () => {
    const token = _kc.tokenParsed;
    return {
        id: (token === null || token === void 0 ? void 0 : token.exfluencyId) || '',
        login: (token === null || token === void 0 ? void 0 : token.preferred_username) || '',
        name: (token === null || token === void 0 ? void 0 : token.given_name) || '',
        surname: (token === null || token === void 0 ? void 0 : token.family_name) || '',
        email: (token === null || token === void 0 ? void 0 : token.email) || '',
        currency: (token === null || token === void 0 ? void 0 : token.exfluencyCurrency) || '',
        timezone: (token === null || token === void 0 ? void 0 : token.exfluencyTimezone) || 'Europe/Warsaw'
    };
};
/**
 * Check if user has any from given roles
 *
 * @param roles - array of roles to check
 * @returns true when user has any role from array.
 */
const hasAnyRole = (roles) => {
    return roles.some(role => _kc.hasRealmRole(role));
};
const UserService = {
    initKeycloak,
    doLogin,
    doLogout,
    isLoggedIn,
    getToken,
    updateToken,
    getUsername,
    hasAnyRole,
    unauthenticatedPath,
    getTokenUserInfo
};
export default UserService;
